import { mediaUrl } from "../../lib/api";
import { Reveal } from "../Reveal";
import { useLang } from "../../context/LanguageContext";

export function Gallery({ images = [] }) {
  const { t } = useLang();
  if (!images.length) return null;
  // Editorial bento spans for a dynamic, photography-forward layout
  const spans = [
    "md:col-span-2 md:row-span-2",
    "md:col-span-1",
    "md:col-span-1",
    "md:col-span-1 md:row-span-2",
    "md:col-span-2",
    "md:col-span-1",
    "md:col-span-1",
    "md:col-span-2",
  ];

  return (
    <section data-testid="course-gallery" className="bg-[#F4F8FF] py-20 md:py-28">
      <div className="px-6 md:px-12 max-w-[1400px] mx-auto">
        <Reveal className="max-w-2xl mb-12">
          <span className="overline">{t("gallery.overline")}</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#0B1220] mt-3">
            {t("gallery.title")}
          </h2>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[200px] md:auto-rows-[220px] gap-3 md:gap-4">
          {images.slice(0, 8).map((img, i) => (
            <Reveal
              key={i}
              delay={(i % 4) * 0.06}
              className={`group overflow-hidden rounded-sm ${spans[i % spans.length]}`}
            >
              <img
                src={mediaUrl(img)}
                alt={`Caso clinico ${i + 1}`}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
